module.exports = __webpack_public_path__ + "../resources/img/ic_layout_mapping_default.edc7c830.svg";